
import { useEffect } from "react";
import { useCollections } from "@/contexts/collections";
import DashboardContent from "@/components/dashboard/DashboardContent";
import { useQueryClient } from "@tanstack/react-query";
import { useMetadata } from "@/hooks/useMetadata";
import { APP_METADATA } from "@/constants/metadata";

const Dashboard = () => {
  const { refreshCollections } = useCollections();
  const queryClient = useQueryClient();
  const { title, description, image } = APP_METADATA.default;
  useMetadata({ title, description, image });

  useEffect(() => {
    console.log("Dashboard mounted, refreshing collections and boards");
    
    // Force immediate refresh of collections to ensure colors are available
    refreshCollections();
    
    // Also refresh content count and boards
    queryClient.invalidateQueries({ queryKey: ["contentCount"] });
    queryClient.invalidateQueries({ queryKey: ["boards"] });
    
    // Invalidate any content queries to ensure they re-fetch with current collection data
    queryClient.invalidateQueries({ queryKey: ["contentItems"] });
    
    // Add interval to periodically refresh collections to ensure order stability
    const intervalId = setInterval(() => {
      console.log("Periodic refresh of collections in Dashboard");
      refreshCollections();
      queryClient.invalidateQueries({ queryKey: ["boards"] });
      // Also make sure to refresh content items
      queryClient.invalidateQueries({ queryKey: ["contentItems"] });
    }, 60000); // Refresh every minute
    
    return () => clearInterval(intervalId);
  }, [refreshCollections, queryClient]);

  return (
    <div className="h-full flex flex-col overflow-hidden bg-background dark:bg-background">
      <DashboardContent />
    </div>
  );
};

export default Dashboard;
